import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { useLang } from "../../context/LangContext";

export default function FAQ() {
  const { c } = useLang();
  const f = c.faq;
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="section" style={{ background: "#0c0c0f" }}>
      <div className="container-x" style={{ maxWidth: 900 }}>
        <div className="reveal" style={{ marginBottom: "3rem" }}>
          <span className="eyebrow">{f.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2.2rem,5vw,4rem)", margin: "1.2rem 0" }}>
            {f.title.pre}<span className="italic-gold">{f.title.em}</span>{f.title.post}
          </h2>
        </div>
        <div style={{ display: "grid", gap: "0.8rem" }}>
          {f.items.map((item, i) => {
            const active = open === i;
            return (
              <div key={i} className="card" style={{ padding: "0", borderColor: active ? "var(--line)" : "rgba(255,255,255,0.07)" }}>
                <button onClick={() => setOpen(active ? -1 : i)} style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center", gap: "1rem", padding: "1.5rem 1.8rem", background: "none", border: "none", cursor: "pointer", textAlign: "left" }}>
                  <span className="font-serif" style={{ fontSize: "1.25rem", color: active ? "var(--gold)" : "var(--text)" }}>{item.q}</span>
                  <span style={{ color: "var(--gold)", flexShrink: 0 }}>{active ? <Minus size={18} /> : <Plus size={18} />}</span>
                </button>
                {active && (
                  <div style={{ padding: "0 1.8rem 1.8rem" }}>
                    <p className="body-text" style={{ fontSize: "0.92rem", margin: 0 }}>{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
